import type { FC, ReactNode } from 'react';
import Dropzone, { type DropzoneProps } from '../../Dropzone/Dropzone';

export interface FileInputProps {
    className?: string;
    hasError?: boolean;
    dropzoneProps?: Omit<DropzoneProps, 'onFile'>;
    onFile: (data: string | File | null) => void;
}

const FileInput: FC<FileInputProps> = props => {
    const { className, dropzoneProps } = props;

    function onFile(data: string | File | null): void {
        const { onFile } = props;
        if (data !== null) {
            onFile(data);
        } else {
            onFile(null);
        }
    }

    function renderDropzone(): ReactNode {
        return <Dropzone onFile={onFile} className="relative" {...dropzoneProps} />;
    }

    return <div className={className}>{renderDropzone()}</div>;
};

export default FileInput;
